/** Platform defaults for QR ordering shell. */
export const DEFAULT_QR_NAME = "Wulooj"
export const DEFAULT_QR_TITLE = "QR Website"

export const DEFAULT_QR_COLORS = {
  primary: "#E57A98",
  secondary: "#1A1A1A",
}

export const DEFAULT_QR_ASSETS = {
  logo: "/brand/logo.svg",
  logoDark: "/brand/logo-dark.png",
  favicon: "/brand/favicon.svg",
  loginBackground: "/brand/login-bg.svg",
}

export const DEFAULT_QR_TEXT = {
  "home.sliderFallback": {
    label: "Hero slider fallback text",
    section: "Home page — hero slider (fallback when no banners load)",
    en: "Discover great food, ordered in seconds.",
    ar: "اكتشف طعاماً رائعاً، يُطلب في ثوانٍ.",
  },
  "search.tagline": {
    label: "Search tagline",
    section: "Search page — empty state",
    en: "Your ultimate guide to great taste",
    ar: "دليلك الأمثل للمذاق الرائع",
  },
  "orders.paymentMethods.loyaltyRewards": {
    label: "Loyalty rewards label",
    section: "Order details page — payment method",
    en: "Wulooj Rewards",
    ar: "مكافآت وُلُوج",
  },
  "branch.welcomeTitle": {
    label: "Branch welcome title",
    section: "QR branch landing page — welcome title",
    en: "Welcome to Wulooj",
    ar: "مرحباً بك في وُلُوج",
  },
  "rating.heroLine": {
    label: "Rating intro line",
    section: "Rating page — survey intro",
    en: "Your opinion shapes the Wulooj experience.",
    ar: "رأيك يصنع تجربة وُلُوج أفضل.",
  },
  "rating.thanksHint": {
    label: "Rating thank you hint",
    section: "Rating page — thank you screen",
    en: "Your feedback helps us improve Wulooj.",
    ar: "ملاحظاتك تساعدنا على تحسين وُلُوج.",
  },
}

export const QR_TEXT_KEYS = Object.keys(DEFAULT_QR_TEXT)

export const QR_TEXT_FIELDS = QR_TEXT_KEYS.map(key => ({
  key,
  label: DEFAULT_QR_TEXT[key].label,
  section: DEFAULT_QR_TEXT[key].section,
}))
